'use client';

import { keepPreviousData, useQuery } from '@tanstack/react-query';
import { fetchRewardsLeaderboard, type LeaderboardParams } from './client';
import type { RewardsLeaderboard } from './models';
import { REWARDS_LEADERBOARD_QK, rewardsLeaderboardKey } from './queryKeys';

export { REWARDS_LEADERBOARD_QK };

const MINUTE = 60 * 1000;

interface UseRewardsLeaderboardParams extends LeaderboardParams {
  enabled?: boolean;
}

/**
 * One query per tab, column, direction, period and page — each is in the key, or a switch
 * would show the previous board from the cache. `keepPreviousData` holds the table in place
 * while the next one is read, so the rows dim instead of collapsing to a
 * skeleton and pushing the page around under the cursor.
 */
export function useRewardsLeaderboard({
  segment,
  metric,
  period,
  page,
  direction,
  enabled = true,
}: UseRewardsLeaderboardParams) {
  return useQuery<RewardsLeaderboard, Error>({
    queryKey: rewardsLeaderboardKey({ segment, metric, period, page, direction }),
    queryFn: () => fetchRewardsLeaderboard({ segment, metric, period, page, direction }),
    enabled,
    staleTime: MINUTE,
    placeholderData: keepPreviousData,
  });
}
